import React from "react";
import styles from "./label.module.scss";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import type { LabelProps } from "@whatslly/types/UI-V2/BaseElements/LabelType";
import upperFirst from "lodash/upperFirst";
import globalStyles from "../../../v2/globalStyles";

export const Label: React.FC<LabelProps> = observer(
  ({ paddingInline, padding, marginBottom, marginTop, fontSize, fontWeight, color, underLine, text, comment, required, className, ...props }) => {
    return (
      <p
        className={classnames(
          styles.label,
          globalStyles[`fs-${fontSize ?? "small"}`],
          globalStyles[`fw-${fontWeight ?? "default"}`],
          globalStyles[`color-${color ?? "main-primary"}`],
          globalStyles[`mb-${marginBottom ?? "small"}`],
          globalStyles[`mt-${marginTop ? "none" : ""}`],
          globalStyles[`p-${padding ? "none" : ""}`],
          globalStyles[`pi-${paddingInline ? "none" : ""}`],
          { [styles.underLine]: underLine },
          className
        )}
        {...props}
      >
        {typeof text === "string" ? upperFirst(text ?? "") : text}
        {comment && <span className={styles.labelComment}>{comment}</span>}
        {required && " *"}
      </p>
    );
  }
);
